export const USER_GROUPS = Object.freeze({
  CAPSOVISION: 'capsovision',
  DISTRIBUTOR: 'distributor',
});

export const DEFAULT_USER_SORT = Object.freeze({ key: 'email', direction: 'asc' });

const GROUP_ROLES = Object.freeze({
  [USER_GROUPS.CAPSOVISION]: ['admin', 'reviewer'],
  [USER_GROUPS.DISTRIBUTOR]: ['distributorAdmin', 'distributorRegular'],
});

export const filterUsersByGroup = (users, group) => {
  const roles = GROUP_ROLES[group] || [];
  return users.filter((user) => roles.includes(user.role));
};

export const isUserSubscribed = (user) => Boolean(
  user.emailSubscribed ?? user.email_sub ?? user.subscribed
);

export const isUserActive = (user) => user.isActive !== false;

// Site admins can view activity for anyone; distributor admins only for
// users in their own distributor organization (mirrors the backend's
// getAuditLogs scoping in server/controllers/auditLogController.js).
export const canViewUserActivity = (currentUser, user) => {
  if (currentUser.role === 'admin') return true;
  return currentUser.role === 'distributorAdmin'
    && Number(currentUser.organizationId) === Number(user.organizationId);
};

export const filterUsersByStatus = (users, status) => users.filter(
  (user) => isUserActive(user) === (status === 'active')
);

export const getNextSort = (currentSort, key) => {
  if (currentSort.key !== key || !currentSort.direction) return { key, direction: 'asc' };
  if (currentSort.direction === 'asc') return { key, direction: 'desc' };
  return { key: null, direction: null };
};

export const createUserRows = (users, organizations) => users.map((user) => {
  const organization = organizations.find(
    (entry) => Number(entry.id) === Number(user.organizationId)
  );
  return {
    user,
    email: user.email || '',
    firstName: user.firstName ?? user.first_name ?? '',
    lastName: user.lastName ?? user.last_name ?? '',
    role: user.role || '',
    organization: organization?.name
      || user.organizationName
      || (Number(user.organizationId) === 1 ? 'CapsoVision (Official)' : String(user.organizationId ?? '')),
    subscription: isUserSubscribed(user) ? 'Subscribed' : 'Not Subscribed',
    status: isUserActive(user) ? 'Active' : 'Inactive',
  };
});

export const sortUserRows = (rows, sort) => {
  if (!sort.key || !sort.direction) return [...rows];
  const direction = sort.direction === 'desc' ? -1 : 1;
  return rows
    .map((row, index) => ({ row, index }))
    .sort((left, right) => {
      const comparison = String(left.row[sort.key] ?? '').localeCompare(
        String(right.row[sort.key] ?? ''),
        undefined,
        { sensitivity: 'base', numeric: true }
      );
      return comparison === 0 ? left.index - right.index : comparison * direction;
    })
    .map(({ row }) => row);
};
